if($('.in-kontakt iframe').length){
    $('article iframe').insertBefore('footer#footer')
}


   /* $('.plus-gallery-wrap').masonry({
        // options
        itemSelector: '.plus-gallery-item',
        percentPosition: true
      });*/

